import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { BNav, BNavItem } from "bootstrap-vue";
import pagesGridConfig from "@/components/Grid/configs/pages";
import pagesPublishedGridConfig from "@/components/Grid/configs/pagesPublished";
import { useUserStore } from "@/stores/userStore";
import Heading from "@/components/Common/Heading.vue";
import LoginRequired from "@/components/Common/LoginRequired.vue";
import GridList from "@/components/Grid/GridList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridPage',
    props: {
        activeList: { default: "my" },
        username: null
    },
    setup(__props) {
        const props = __props;
        const userStore = useUserStore();
        library.add(faPlus);
        return { __sfc: true, userStore, props, faPlus, BNav, BNavItem, pagesGridConfig, pagesPublishedGridConfig, Heading, LoginRequired, GridList };
    }
});
